module.exports = __webpack_public_path__ + "static/elicon-bw-0c400e2710c0179c02be3ff2d2a7e1f1.jpg";